<template>
    <the-mask
        :id="id"
        v-model="value"
        placeholder="DD/MM/YYYY"
        class="Form__date-input fui-input"
        mask="##/##/####"
        :pattern="pattern.toString().slice(1, -1)"
        :name="name"
        :masked="true"
        :required="required"
    />
</template>

<script>
import { TheMask } from 'vue-the-mask';

export default {
    components: { TheMask },

    props: {
        name: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        value: '',
        pattern: /\d{2}\/\d{2}\/\d{4}/
    }),

    watch: {
        value(newValue) {
            this.$emit('input', newValue);
        }
    }
};
</script>
